import { render, staticRenderFns } from "./repeatsentence.vue?vue&type=template&id=333b540a&scoped=true&"
import script from "./repeatsentence.vue?vue&type=script&lang=js&"
export * from "./repeatsentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b540a",
  null
  
)

export default component.exports